import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LodeUserFormDataService {
  lodeUserForm;
  newUserForm;
  //when the back button presses before the user data loaded into lode-user-form from the API call,this flag must be needed to prevent showing the toaster for unsaved changes.
  initialChangesOfForm:boolean;

}
